import { render } from "./CustomerData.vue?vue&type=template&id=bbfdf196&scoped=true&ts=true"
import script from "./CustomerData.vue?vue&type=script&lang=ts"
export * from "./CustomerData.vue?vue&type=script&lang=ts"

import "./CustomerData.vue?vue&type=style&index=0&id=bbfdf196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbfdf196"]])

export default __exports__